import React, { useState } from 'react';
import './FaceSubjects.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';

export default function FaceSubjects({ subjects, fallbackText, onSelectFace, onEditClick, onDeleteClick, current }) {
    if (subjects) {
        return (
            <section className="facesubjects-section">
                {subjects.length === 0 && <p className="fallback-text">{fallbackText}</p>}
                {subjects.length > 0 && (
                    <ul className="facesubjects-items">
                        {subjects.map((subject) => (
                            <li key={subject.image_id}
                                className="facesubjects-li">
                                <div className={`facesubjects-item ${subject.id == current.id ? 'facesubjects-item-active' : ''} `}>
                                    <h3 className="facesubjects-heading" onClick={() => onSelectFace(subject)}>
                                        {subject.subject}
                                    </h3>
                                    <div className="facesubjects-actions">
                                        <div className="facesubjects-action" onClick={() => onEditClick(subject)}>
                                            <FontAwesomeIcon icon={faPen} />
                                        </div>
                                        <div className="facesubjects-action" onClick={() => onDeleteClick(subject)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </section>
        );
    }
}
